import { createBrowserHistory } from 'history';

// Create a custom history object
export const history = createBrowserHistory();
